import * as types from './types.action';

export function setServerOfflineSuccess(serverOffline) {
  return {
    type: types.SET_SERVER_OFFLINE_SUCCESS,
    serverOffline
  };
}

export function setServerOffline(serverOffline) {
  return dispatch => dispatch(setServerOfflineSuccess(serverOffline));
}



// WEBPACK FOOTER //
// ./actions/serverOffline.action.js